import { Box, Button, Collapse, MenuItem, Paper } from "@mui/material";
import type React from "react";
import { useEffect, useRef, useState } from "react";
import type { AdvertisementSort } from "../../../../api/rest/generated/aPIForPublicPartOfApplicationInzerceNemovitéhoMajetku.schemas.ts";
import type { OverviewForm } from "../../../../hooks/useOverview.ts";
import {useHomeFilter} from "../../../../hooks/useHomeFilter.ts";

const sortLabels: Record<AdvertisementSort, string> = {
	ExpirationAsc: "Dle expirace nabídky (A > Z)",
	ExpirationDesc: "Dle expirace nabídky (Z > A)",
	AlphabeticalAsc: "Abecedně - vzestupně (A > Z)",
	AlphabeticalDesc: "Abecedně - sestupně (Z > A)",
	Cheapest: "Od nejlevnějších",
	MostExpensive: "Od nejdražších",
	Newest: "Od nejnovějších",
	Oldest: "Od nejstarších",
};

const SortFilter: React.FC<{ overviewForm: OverviewForm; variant?: "contained" | "outlined"; fullwidth?: boolean }> = ({
	overviewForm,
	variant,
	fullwidth,
}) => {
    const homeFilter = useHomeFilter(overviewForm);
	const [open, setOpen] = useState(false);
	const menuRef = useRef<HTMLDivElement | null>(null); // Reference to the Paper component
	const buttonRef = useRef<HTMLButtonElement | null>(null); // Reference to the Button component

	const handleOpen = () => {
		setOpen(!open);
	};

	const handleClose = () => {
		setOpen(false);
	};

	// Close the menu when clicking outside of the button or menu
	useEffect(() => {
		// @ts-expect-error
		const handleClickAway = (event) => {
			// Check if the click is outside the button and menu
			if (
				menuRef.current &&
				!menuRef.current.contains(event.target) &&
				buttonRef.current &&
				!buttonRef.current.contains(event.target)
			) {
				// Close the menu if clicked outside
				setOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickAway);

		return () => {
			document.removeEventListener("mousedown", handleClickAway);
		};
	}, []);
	return (
		<overviewForm.Field name="sort">
			{(fieldApi) => {
                const handleValueChange = (newValue: typeof fieldApi.state.value) => {
					fieldApi.setValue(newValue);
                    homeFilter.manualSearch();
                    handleClose();
				};

				return (
					<Box overflow="visible" position="relative">
						<Button
							ref={buttonRef}
							fullWidth={fullwidth}
							sx={{ position: "relative" }}
							color="secondary"
							variant={variant ?? "outlined"}
							onClick={handleOpen}
						>
							Seřadit {sortLabels[(fieldApi.state.value as AdvertisementSort) ?? "Newest"]}
						</Button>
						<Collapse in={open}>
							<Paper
								ref={menuRef}
								sx={{
									position: "absolute",
									display: open ? "block" : "none",
									zIndex: 9999,
									top: "100%", // Position the Paper above the button
									right: 0, // Align Paper to the left of the button
									marginBottom: 1, // Optional: adds some space between the button and menu
								}}
							>
								<MenuItem
									onClick={() => {
										handleValueChange("ExpirationAsc");
									}}
								>
									{sortLabels.ExpirationAsc}
								</MenuItem>
								<MenuItem
									onClick={() => {
										handleValueChange("ExpirationDesc");
									}}
								>
									{sortLabels.ExpirationDesc}
								</MenuItem>
								<MenuItem
									autoFocus={true}
									onClick={() => {
										handleValueChange("Newest");
									}}
								>
									{sortLabels.Newest}
								</MenuItem>
								<MenuItem
									onClick={() => {
										handleValueChange("Oldest");
									}}
								>
									{sortLabels.Oldest}
								</MenuItem>
								<MenuItem
									onClick={() => {
										handleValueChange("Cheapest");
									}}
								>
									{sortLabels.Cheapest}
								</MenuItem>
								<MenuItem
									onClick={() => {
										handleValueChange("MostExpensive");
									}}
								>
									{sortLabels.MostExpensive}
								</MenuItem>
								<MenuItem
									onClick={() => {
										handleValueChange("AlphabeticalAsc");
									}}
								>
									{sortLabels.AlphabeticalAsc}
								</MenuItem>
								<MenuItem
									onClick={() => {
										handleValueChange("AlphabeticalDesc");
									}}
								>
									{sortLabels.AlphabeticalDesc}
								</MenuItem>
							</Paper>
						</Collapse>
					</Box>
				);
			}}
		</overviewForm.Field>
	);
};

export default SortFilter;
